import type { NodeStyle } from "./layout.types";
import {
  Align,
  FlexDirection,
  Justify,
  Overflow,
  PositionType,
  Wrap
} from "./yoga.types";

/**
 * During style computation if any of the style prop is not provided, we
 * substitute it with the default value specified here.
 */
export const defaultNodeLayoutStyle: NodeStyle = {
  width: "auto",
  height: "auto",
  paddingTop: 0,
  paddingBottom: 0,
  paddingLeft: 0,
  paddingRight: 0,
  marginTop: 0,
  marginBottom: 0,
  marginLeft: 0,
  marginRight: 0,

  alignContent: Align.Baseline,
  alignItems: Align.Auto,
  alignSelf: Align.Stretch,

  justifyContent: Justify.FlexStart,

  flexBasis: "auto",
  flexGrow: 0,
  flexShrink: 1,
  flexWrap: Wrap.NoWrap,
  flexDirection: FlexDirection.Column,

  gapRow: 0,
  gapColumn: 0,

  overflow: Overflow.Visible, // Scroll won't work as intended
  position: PositionType.Relative,

  visible: true,

  // Non-layout styles
  borderWidth: 0,
  borderColor: "#000000",
  borderRadius: 0
};
